/* global document, window */

(() => {
  const modal = document.getElementById('gt-email-modal');
  if (!modal) return;

  const dialog = modal.querySelector('.gt-email-modal__dialog');
  const emailInput = modal.querySelector('input[name="contact[email]"]');
  const closeTargets = modal.querySelectorAll('[data-gt-modal-close]');
  let lastTrigger = null;

  const setPageScrollLock = (isLocked) => {
    document.documentElement.classList.toggle('gt-email-modal-open', isLocked);
    document.body.classList.toggle('gt-email-modal-open', isLocked);
  };

  const canOpenForSource = (source) => {
    if (source === 'nav') return modal.dataset.openFromNav === 'true';
    if (source === 'arsenal') return modal.dataset.openFromArsenal === 'true';
    return true;
  };

  const openModal = (trigger) => {
    lastTrigger = trigger || null;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    setPageScrollLock(true);
    setTimeout(() => emailInput && emailInput.focus(), 0);
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    setPageScrollLock(false);
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gt-open-email-modal]');
    if (!trigger) return;
    const source = trigger.getAttribute('data-gt-open-email-modal');
    if (!canOpenForSource(source)) return;
    event.preventDefault();
    openModal(trigger);
  });

  closeTargets.forEach((el) => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target === dialog) return;
  });

  // Re-open modal after Shopify customer form POST redirect so success/error is visible.
  const { hash, search } = window.location;
  const isModalFormHash = hash.startsWith('#gt-email-modal-form-');
  const hasCustomerPostState =
    search.includes('customer_posted=true') ||
    search.includes('form_type=customer') ||
    search.includes('customer%5Bemail%5D');
  if (isModalFormHash && hasCustomerPostState) openModal(null);
})();
